"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHistoryClient = void 0;
const HistoryClient_1 = require("@juvare/platform-sdk-js/HistoryClient");
const react_1 = __importDefault(require("react"));
function useHistoryClient(entity, baseUrl, tokenProvider) {
    return react_1.default.useMemo(() => new HistoryClient_1.HistoryClient(entity, baseUrl, tokenProvider), [entity, baseUrl, tokenProvider]);
}
exports.useHistoryClient = useHistoryClient;
